import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  imports: [RouterModule, TablerIconsModule, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrls: [],
})
export class AppFooterComponent {
  
}
